export default {
    ABOUT: "about"
};
